import { openProductSearch } from "../product-detail/navigation";
import { Menu, Search } from "lucide-react";
import { UserProfile } from "../UserProfile";
import { FeedbackHeader } from "../feedback/FeedbackHeader";
import "./HeaderBar.css";

interface HeaderBarProps {
  isNavigationOpen: boolean;
  onOpenNavigation: () => void;
  onNavigate?: (view: "profile" | "settings" | "dashboard") => void;
}

export function HeaderBar({
  isNavigationOpen,
  onOpenNavigation,
  onNavigate,
}: HeaderBarProps) {
  return (
    <header className="headerbar" data-node-id="1039:5072">
      <button
        type="button"
        className="headerbar__menu"
        aria-label="Open navigation"
        aria-controls="main-navigation"
        aria-expanded={isNavigationOpen}
        onClick={onOpenNavigation}
      >
        <Menu aria-hidden="true" />
      </button>

      <a href="/?view=dashboard" aria-label="Dashboard" onClick={event => { if (onNavigate && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey) { event.preventDefault(); onNavigate("dashboard"); } }}>
      <img
        className="headerbar__logo"
        src="/lantmannen-unibake.svg"
        alt="Lantmännen Unibake"
      />

      </a>
      <div className="headerbar__spacer" />
      <form className="headerbar__search" role="search" onSubmit={event => { event.preventDefault(); openProductSearch(String(new FormData(event.currentTarget).get("q") || "")); }}>
        <button type="submit" aria-label="Find products"><Search size={20} aria-hidden="true" /></button>
        <input name="q" type="search" aria-label="Quicksearch products" placeholder="Search products, item number or GTIN…" />
      </form>
      <FeedbackHeader />
      <UserProfile variant="headerbar" onNavigate={onNavigate} />
    </header>
  );
}
